import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";

const ModalScreen = (props) => {
  return (
    <Drawer
      anchor="right"
      open={props.open}
      onClose={(_, reason) => {
        if (reason === "escapeKeyDown") {
          props.onClose();
        }
      }}
      className={props.className}
    >
      <Box>
        <Toolbar className="Toolbar">
          <Typography className="ScreenTitle">{props.title}</Typography>
          <IconButton onClick={props.onClose}>
            <CloseIcon />
          </IconButton>
        </Toolbar>
        <Box className="ModalContainer">{props.children}</Box>
      </Box>
    </Drawer>
  );
};

export default styled(ModalScreen)(
  ({ theme }) => `
  .MuiDrawer-paper {
    width: 375px;
    padding: 0px;
  }

  .ModalContainer {
    padding: 12px;
  }

  .ScreenTitle {
    flex-grow: 1;
    font-family: milliard-light;
  }

  .Toolbar {
    background-image:
      linear-gradient(90deg, ${theme.palette.secondary.main} 30%, ${theme.palette.primary.main} 95%);
    background-size: 100% 5px;
    background-position: right 100%;
    background-repeat: no-repeat;
  }
`,
);
